import React from 'react';
import StatusBadge from '../StatusBadge';
import StudentEnrollmentsSections from '../StudentList/StudentEnrollmentsSections';
import { mapEnrollmentStudentDetails } from '../../utils/batchEnrollmentMapper';

const EnrollmentStudentCard = ({ enrollment, isExpanded, onToggle }) => {
  const studentDetails = mapEnrollmentStudentDetails(enrollment);

  return (
    <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      <div className="flex justify-between items-start gap-3">
        <div>
          <p className="font-medium theme-text">{studentDetails.header.fullName}</p>
          <p className="text-sm theme-text-secondary">{studentDetails.header.email}</p>
          <p className="text-xs theme-text-secondary mt-1">
            Enrolled: {studentDetails.header.enrolledOn}
          </p>
          {studentDetails.header.batchStatus && (
            <div className="mt-1">
              <StatusBadge status={studentDetails.header.batchStatus} className="text-xs" />
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onToggle}
          className="text-blue-600 hover:text-blue-800 text-sm font-medium"
        >
          {isExpanded ? 'Hide Details' : 'View Details'}
        </button>
      </div>

      {isExpanded && (
        <div className="mt-3 border-t pt-3 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div className="space-y-1">
              <h4 className="font-semibold theme-text">Personal Information</h4>
              <p className="theme-text-secondary">
                Phone: <span className="theme-text">{studentDetails.personal.phoneNumber}</span>
              </p>
              <p className="theme-text-secondary">
                Current Address: <span className="theme-text">{studentDetails.personal.currentAddress}</span>
              </p>
              <p className="theme-text-secondary">
                Domain: <span className="theme-text">{studentDetails.personal.domainName}</span>
              </p>
            </div>

            <div className="space-y-1">
              <h4 className="font-semibold theme-text">Summary (this batch)</h4>
              <p className="theme-text-secondary">
                Batch Status: <span className="theme-text">{studentDetails.enrollment.batchStatus}</span>
              </p>
              <p className="theme-text-secondary">
                Placement Status: <span className="theme-text">{studentDetails.enrollment.placementStatus}</span>
              </p>
              <p className="theme-text-secondary">
                Attendance: <span className="theme-text">{studentDetails.enrollment.attendancePercentage}</span>
              </p>
              <p className="theme-text-secondary">
                Completion Date: <span className="theme-text">{studentDetails.enrollment.courseCompletionDate}</span>
              </p>
            </div>

            <div className="space-y-1">
              <h4 className="font-semibold theme-text">Academic Information</h4>
              <p className="theme-text-secondary">
                Highest Degree: <span className="theme-text">{studentDetails.academic.highestDegree}</span>
              </p>
              <p className="theme-text-secondary">
                Highest Degree %: <span className="theme-text">{studentDetails.academic.highestDegreePercentage}</span>
              </p>
              <p className="theme-text-secondary">
                10th %: <span className="theme-text">{studentDetails.academic.tenthPercentage}</span>
              </p>
              <p className="theme-text-secondary">
                12th %: <span className="theme-text">{studentDetails.academic.twelfthPercentage}</span>
              </p>
            </div>
          </div>
          <StudentEnrollmentsSections
            enrollments={[enrollment]}
            domain={enrollment.student?.domain}
            repeatDomain={false}
          />
        </div>
      )}
    </div>
  );
};

export default EnrollmentStudentCard;

